import React, { useEffect, useId, useState } from "react";
import { createMarkup } from "utils";

import { LoadingWrapper } from "./styled";

const LoadingComponent = ({ idParticles, messages }) => {
  require("particles.js");
  const [message, setMessage] = useState(messages[0]);
  const uniqueId = useId();
  const particleId = idParticles + "-" + uniqueId.replace(/:/g, "");

  useEffect(() => {
    particlesJS(particleId, {
      particles: {
        number: {
          value: 76,
          density: {
            enable: true,
            value_area: 868.0624057955,
          },
        },
        color: {
          value: "#ffffff",
        },
        shape: {
          type: "circle",
          stroke: {
            width: 0,
            color: "#000000",
          },
          polygon: {
            nb_sides: 5,
          },
          image: {
            src: "img/github.svg",
            width: 100,
            height: 100,
          },
        },
        opacity: {
          value: 0.5,
          random: false,
          anim: {
            enable: false,
            speed: 1,
            opacity_min: 0.1,
            sync: false,
          },
        },
        size: {
          value: 5,
          random: true,
          anim: {
            enable: false,
            speed: 40,
            size_min: 0.1,
            sync: false,
          },
        },
        line_linked: {
          enable: true,
          distance: 150,
          color: "#ffffff",
          opacity: 0.4,
          width: 1,
        },
        move: {
          enable: true,
          speed: 6,
          direction: "none",
          random: false,
          straight: false,
          out_mode: "out",
          bounce: false,
          attract: {
            enable: false,
            rotateX: 600,
            rotateY: 1200,
          },
        },
      },
      interactivity: {
        detect_on: "canvas",
        events: {
          onhover: {
            enable: false,
            mode: "repulse",
          },
          onclick: {
            enable: false,
            mode: "push",
          },
          // Own the resize listener so it can be removed when this loader closes.
          resize: false,
        },
        modes: {
          grab: {
            distance: 400,
            line_linked: {
              opacity: 1,
            },
          },
          bubble: {
            distance: 400,
            size: 40,
            duration: 2,
            opacity: 8,
            speed: 3,
          },
          repulse: {
            distance: 200,
            duration: 0.4,
          },
          push: {
            particles_nb: 4,
          },
          remove: {
            particles_nb: 2,
          },
        },
      },
      retina_detect: true,
    });

    const instances = (window as any).pJSDom;
    const instance = instances[instances.length - 1];
    const particles = instance.pJS;
    const handleResize = () => {
      particles.fn.retinaInit();
      particles.fn.canvasSize();
      particles.fn.vendors.densityAutoParticles();
    };
    window.addEventListener("resize", handleResize);

    let seconds = 0;
    const interval = setInterval(() => {
      seconds++;
      if (seconds == 6) {
        setMessage(messages[1]);
      }

      if (seconds == 11) {
        setMessage(messages[2]);
      }

      if (seconds == 14) {
        setMessage(messages[3]);
      }
    }, 1000);
    return () => {
      clearInterval(interval);
      window.removeEventListener("resize", handleResize);
      window.cancelAnimationFrame(particles.fn.drawAnimFrame);
      window.cancelAnimationFrame(particles.tmp.checkAnimFrame);
      particles.fn.particlesEmpty();
      particles.canvas.el.remove();
      // particles.js's destroy method clears the registry for every loader.
      const index = instances.indexOf(instance);
      if (index !== -1) instances.splice(index, 1);
    };
  }, [particleId]);

  return (
    <LoadingWrapper>
      <div className="particles-div" id={particleId}></div>
      <div dangerouslySetInnerHTML={createMarkup(message)}></div>
    </LoadingWrapper>
  );
};

export default LoadingComponent;
